import { jsx } from "react/jsx-runtime";
import React__default from "react";
import AntInput from "antd/es/input";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import './Input.css';/* empty css           */
const AntTextarea = AntInput.TextArea;
const InternalInput = React__default.forwardRef(function Input({ className, placeholder = "Введите", allowClear: allowClearProp = false, onClear, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    AntInput,
    {
      ref,
      allowClear: allowClearProp ? {
        clearIcon: /* @__PURE__ */ jsx(
          Button,
          {
            type: "link",
            onClick: onClear,
            icon: /* @__PURE__ */ jsx(Icon, { name: "cross", size: 18, sticker: "input-clear-icon" })
          }
        )
      } : false,
      className: classnames("perxis-auto-input", className),
      placeholder,
      ...props
    }
  );
});
const Textarea = React__default.forwardRef(function Textarea2({ className, placeholder = "Введите", ...props }, ref) {
  return /* @__PURE__ */ jsx(
    AntTextarea,
    {
      ref,
      allowClear: false,
      className: classnames(["perxis-auto-input", "perxis-auto-textarea"], className),
      placeholder,
      ...props
    }
  );
});
const Input2 = InternalInput;
Input2.Textarea = Textarea;
export {
  Input2 as default
};
//# sourceMappingURL=Input.js.map
